import React from 'react'
import moment from 'moment'
import { Form, Input, Button, Modal, InputNumber, DatePicker, Select } from 'antd'
import { keys } from '../../actions/eventForm'
import ImageUpload from '../../components/ImageUpload'
import MultiLanguageField from '../../components/MultiLanguageField'
import V2Editor from '../../components/V2Editor'

const FormItem = Form.Item
const { Option } = Select

class ItemForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleOnSubmit = this.handleOnSubmit.bind(this)
    this.handleOnDelete = this.handleOnDelete.bind(this)
  }

  handleOnSubmit(e) {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (err) {
        return
      }
      this.props.onSubmit(values)
    })
  }

  handleOnDelete(e) {
    e.preventDefault()
    const handleOnOk = () => { this.props.onDelete() }
    Modal.confirm({
      title: 'Delete Item',
      content: 'Are you sure to delete this item?',
      okType: 'danger',
      onOk() {
        handleOnOk()
      },
      onCancel() {
        // console.log('Cancel')
      },
    })
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
        md: { span: 10 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 12,
          offset: 7,
        },
      },
    }
    const isCreateForm = this.props.type === 'create'
    return (
      <Form onSubmit={this.handleOnSubmit}>
        <FormItem label='Order' {...formItemLayout}>
          {getFieldDecorator('index', {
            initialValue: 1,
            rules: [{ required: true, message: 'Please input a valid value.' }],
          })(<InputNumber />)}
        </FormItem>
        <FormItem label='Snag (for url)' {...formItemLayout}>
          {getFieldDecorator('snag', {
          })(<Input />)}
        </FormItem>
        <FormItem label='Date' {...formItemLayout}>
          {getFieldDecorator('date', {
            initialValue: moment('1990/09/05 00:00:00'),
          })(<DatePicker showTime format='YYYY/MM/DD HH:mm:00' />)}
        </FormItem>
        <FormItem label='Image (if any)' {...formItemLayout}>
          {getFieldDecorator('pic', {
          })(<ImageUpload multiple />)}
        </FormItem>
        <MultiLanguageField
          label='Header'
          field='header'
          formItemLayout={formItemLayout}
          getFieldDecorator={getFieldDecorator}
          textArea={false}
          isRequired={false}
          data={this.props.formFieldValues}
        />
        {this.props.useDom &&
          <>
            <V2Editor
              label='Content (For preview)'
              field='content_dom'
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
              backgroundColor='rgb(65, 65, 65)'
            />
          </>
          ||
          <>
            <MultiLanguageField
              label='Content ( for preview )'
              field='content'
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
              textArea
              data={this.props.formFieldValues}
            />
          </>
        }
        <FormItem label='Category' {...formItemLayout}>
          {getFieldDecorator('category', {
          })(<Select placeholder='Select category'>
            <Option value='event_miscellaneous'>Miscellaneous</Option>
            <Option value='social_function'>Social Function</Option>
            <Option value='professional'>Professional</Option>
          </Select>)}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button
            loading={this.props.isCreateItemLoading || this.props.isEditItemLoading}
            type='primary'
            htmlType='submit'
            style={{ marginRight: '12px' }}
          >
            {isCreateForm ? 'Create' : 'Save'}
          </Button>
          {
            !isCreateForm &&
            <Button
              loading={this.props.isDeleteItemLoading}
              type='danger'
              htmlType='button'
              onClick={this.handleOnDelete}
            >
              Delete
            </Button>
          }
        </FormItem>
      </Form>
    )
  }
}

const CustomizedForm = Form.create({
  onFieldsChange(props, changedFields) {
    props.onFieldsChange(changedFields)
  },
  mapPropsToFields(props) {
    const { formFieldValues = {} } = props
    const ks = keys.length === 0 ? Object.keys(formFieldValues) : keys
    const fields = ks.reduce((prev, key) => (
      { ...prev, [key]: Form.createFormField(formFieldValues[key]) }
    ), {})
    return fields
  },
  // onValuesChange(_, values) {
  //   console.log(values)
  // },
})(ItemForm)

export default CustomizedForm
